import React from "react";
import { useNavigate } from "react-router-dom";
import { useLang } from "@/i18n";
import { Shell } from "@/components/Shell";
import { User, Storefront, Truck, CaretLeft } from "@phosphor-icons/react";

export default function AddVisit() {
  const { t } = useLang();
  const nav = useNavigate();
  const buttons = [
    { key: "doctor_visit", icon: User, color: "bg-blue-600", to: "/visit/doctor" },
    { key: "retailer_visit", icon: Storefront, color: "bg-emerald-600", to: "/visit/retailer" },
    { key: "stockist_visit", icon: Truck, color: "bg-violet-600", to: "/visit/stockist" },
  ];
  return (
    <Shell title={t("add_visit")}
      back={<button onClick={() => nav("/")} data-testid="back-btn"><CaretLeft size={22} /></button>}>
      <div className="space-y-4 mt-4">
        {buttons.map(({ key, icon: Icon, color, to }) => (
          <button
            key={key}
            data-testid={`addvisit-${key}`}
            onClick={() => nav(to)}
            className={`w-full min-h-[96px] rounded-2xl ${color} text-white flex flex-col items-center justify-center gap-2 font-head font-bold text-lg active:scale-[0.98] transition-transform`}
          >
            <Icon size={36} weight="bold" />
            {t(key)}
          </button>
        ))}
      </div>
    </Shell>
  );
}
